<template>
  <div>
    <breadcrump :breadcrump="breadcrump"></breadcrump>

    <div id="socialWindow">
      <h1
        class="title content is-size-5 has-text-centered"
      >{{ computedProduct1.name }} vs {{ computedProduct2.name }}</h1>

      <div class="columns is-gapless is-mobile">
        <div class="column">
          <div class="columns is-vcentered is-mobile is-gapless">
            <div class="column is-3-tablet">
              <specification-panel :product="computedProduct1"></specification-panel>
            </div>
            <div class="column">
              <figure class="image is-square">
                <img :src="computedProduct1.image_src" />
              </figure>
            </div>
          </div>
        </div>

        <div class="column">
          <div class="columns is-vcentered is-mobile is-gapless">
            <div class="column">
              <figure class="image is-square">
                <img :src="computedProduct2.image_src" />
              </figure>
            </div>
            <div class="column is-3-tablet">
              <specification-panel :product="computedProduct2"></specification-panel>
            </div>
          </div>
        </div>
      </div>
    </div>

    <h2 class="subtitle">Porównanie specyfikacji</h2>

    <side-by-side-compare-table :product1="computedProduct1" :product2="computedProduct2"></side-by-side-compare-table>
    <social-share-buttons :url="urlContent" :title="title"></social-share-buttons>

    <template v-if="isOffersOn">
      <h2 class="subtitle">Kup {{ computedProduct1.name }}</h2>

      <pricing-table :filterkeyword="computedProduct1.name" :filtermetal="computedProduct1.metal"></pricing-table>

      <h2 class="subtitle">Kup {{ computedProduct2.name }}</h2>

      <pricing-table :filterkeyword="computedProduct2.name" :filtermetal="computedProduct2.metal"></pricing-table>
    </template>
  </div>
</template>

<script>
import json from "../database.json";

import SpecificationPanel from "./SpecificationPanel";
import SideBySideCompareTable from "./SideBySideCompareTable";
import PricingTable from "./PricingTable";
import Breadcrump from "./Breadcrump";
import SocialShareButtons from "./SocialShareButtons";

export default {
  data() {
    return {
      product1: null,
      product2: null,
      database: null,
      title: "ZbierajMonety.pl",
      description: "",
      imageSrc: "",
      urlContent: "",
      currentVariant1: "1oz",
      currentVariant2: "1oz"
    };
  },
  watch: {
    product2() {
      if (this.product1 != null && this.product2 != null) {
        const metalDescription1 =
          this.product1.metal == "gold" ? "Złoty" : "Srebrny";
        const metalDescription2 =
          this.product2.metal == "gold" ? "Złoty" : "Srebrny";
        this.title = `Porównanie ${metalDescription1} ${this.product1.name} ${this.currentVariant1} vs ${metalDescription2} ${this.product2.name} ${this.currentVariant2}`;
        this.product2.metal == "gold" ? "Złoty" : "Srebrny";
        this.description = `Sprawdź którą monetę lepiej kupić. Szczegółowe porównanie monet ${metalDescription1} ${this.product1.name} ${this.currentVariant1} oraz ${metalDescription2} ${this.product2.name} ${this.currentVariant2}.`;

        const currentAbsoluteUrl = new URL(window.location.href);
        const currentAbsoluteUrlSplitted = currentAbsoluteUrl.pathname.split(
          "/"
        );
        const endSlug =
          currentAbsoluteUrlSplitted[currentAbsoluteUrlSplitted.length - 2];
        this.imageSrc = `https://zbierajmonety.pl/img${this.$route.path}${endSlug}.png`;

        this.urlContent = `https://zbierajmonety.pl${currentAbsoluteUrl.pathname}`;
      }
    }
    // $route() {
    //   this.product1 = this.database[this.$route.params.product1];
    //   this.product2 = this.database[this.$route.params.product2];
    // }
  },
  computed: {
    computedProduct1() {
      return this.mergeProductWithVariant(this.product1, this.currentVariant1);
    },
    computedProduct2() {
      return this.mergeProductWithVariant(this.product2, this.currentVariant2);
    },
    breadcrump() {
      return [
        {
          name: "Porównanie",
          to: {
            name: "comparechoice"
          }
        },
        {
          name: `${this.product1.name} vs ${this.product2.name}`,
          to: {
            name: "compare",
            params: {
              product1: this.product1.slug,
              product2: this.product2.slug
            }
          }
        }
      ];
    }
  },
  metaInfo() {
    return {
      title: this.title,
      meta: [
        // general
        { name: "description", content: this.description },

        // Schema.org for Google
        { itemprop: "name", content: this.title },
        { itemprop: "description", content: this.description },
        { itemprop: "image", content: this.imageSrc },

        // twitter
        { name: "twitter:card", content: "summary_large_image" },
        { name: "twitter:title", content: this.title },
        { name: "twitter:description", content: this.description },
        { name: "twitter:image", content: this.imageSrc },
        { property: "og:image:width", content: 650 * 2 },
        { property: "og:image:height", content: 341 * 2 },

        // Open Graph general (Facebook, Pinterest & Google+)
        { property: "og:title", content: this.title },
        { property: "og:description", content: this.description },
        { property: "og:image", content: this.imageSrc },
        { property: "og:image:url", content: this.imageSrc },
        { property: "og:image:alt", content: this.title },
        { property: "og:url", content: this.urlContent },
        { property: "og:locale", content: "pl_PL" },
        { property: "og:type", content: "website" }

        // Open Graph - Product (e-commerce)
        // { property: 'product:price:currency', content: 'PLN'},
        // { property: 'product:price:amount', content: '6337.16'},
        // { property: 'product:brand', content: 'United States Mint'},
      ]
    };
  },
  beforeMount() {
    // prepare database:

    this.database = {};
    for (var i in json) {
      var elem = json[i];
      this.database[`${elem.slug}-${elem.metal}`] = elem;
    }
    let metal1 = this.$route.params.metal1 == "zloto" ? "gold" : "silver";
    this.product1 = this.database[`${this.$route.params.slug1}-${metal1}`];
    this.currentVariant1 = this.$route.params.weight1.replace("_", "/");

    let metal2 = this.$route.params.metal2 == "zloto" ? "gold" : "silver";
    this.product2 = this.database[`${this.$route.params.slug2}-${metal2}`];
    this.currentVariant2 = this.$route.params.weight2.replace("_", "/");
  },
  components: {
    SpecificationPanel,
    SideBySideCompareTable,
    PricingTable,
    Breadcrump,
    SocialShareButtons
  }
};
</script>

<style scoped>
.subtitle {
  margin-top: 2rem;
}
</style>
